import React from 'react';

import {
  Input,
  Button,
  Icon,
  Row,
  Col,
  message
} from 'antd';

import {
  _postThreeP 
} from "../../services";

class ThreePInput extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      value: ''
    }
  }

  render() {
    return (
      <Row gutter={4}>
        <Col span={22}>
          <Input
            value={this.state.value}
            onChange={(e) => this.setState({ value: e.target.value })}
            placeHolder={'Text Here'} />
        </Col>
        <Col span={2}>
          <Button
            size="small"
            onClick={this.onAddClick}>
            <Icon type="plus" />
          </Button>
        </Col>
      </Row >
    );

  }

  onAddClick = async () => {

    if (this.state.value.trim().length === 0) {
      message.error('Please provide a valid value')
      return;
    }
    
    if (this.props.level !== 1 && !this.props.parentId) {
      message.error('Please select a parent')
      return;
    }

    await _postThreeP({ 
      level: this.props.level,
      value: this.state.value,
      parentId: this.props.parentId
    })

    /* Reset the input */
    this.setState({
      value: ''
    }, () => {
      this.props.getData()
    })
  }

}

export default ThreePInput


// WEBPACK FOOTER //
// ./src/components/three-ps/input.js